import * as tslib_1 from "tslib";
import commitDarkModeTheme from './commitDarkModeTheme';
import { getIsDarkTheme } from 'owa-fabric-theme';
export default function saveDarkModeOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            commitDarkModeTheme(getIsDarkTheme());
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=saveDarkModeOption.js.map